<template>
  <div class="role_div">
    <div class="title">店员管理</div>
    <div class="center_box">
      <div class="center_title">
        <!-- @click="AddRole" -->
        <span class="center_left_btn"
              @click="handleClick(1)">新 增</span>
      </div>
      <div class="center-contain">
        <el-table :data="MemberList"
                  :header-cell-style="{background:'#F5F6FA'}"
                  style="width: 100%">
          <el-table-column align="center"
                           prop="real_name"
                           label="姓名">
          </el-table-column>
          <el-table-column align="center"
                           prop="cellphones"
                           label="账号名称">
          </el-table-column>
          <el-table-column align="center"
                           prop="role_name"
                           label="关联角色">
          </el-table-column>
          <el-table-column align="center"
                           prop="times"
                           label="创建时间">
            <template slot-scope="scope">
              {{changeTime(scope.row.times)}}
            </template>
          </el-table-column>
          <el-table-column align="center"
                           label="启用状态">
            <template slot-scope="scope">
              <div v-if="scope.row.status==1"
                   class="RoleStatus">
                <div class="Yuan"> </div>
                <div class="name">启用</div>
              </div>
              <div v-else
                   class="RoleStatus">
                <div class="RYuan"> </div>
                <div class="name">禁用</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text"
                         size="small"
                         @click="handleClick(2,scope.row)">编辑</el-button>
              <el-button @click="handleClick(3,scope.row)"
                         type="text"
                         size="small"
                         class="deletcol">删除</el-button>
                                      <el-button type="text" size="small" @click="handleClick(4,scope.row)">{{scope.row.status==0?'启用':'禁用'}}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="page">
          <el-pagination @size-change="sizeChange"
                         @current-change="handleSizeChange"
                         :current-page="page"
                         :page-sizes="[10, 20, 30, 40]"
                         :page-size="size"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="total"
                         background>
          </el-pagination>
        </div>
      </div>

    </div>
    <div v-if="viewDetail==true">
      <account-con @closeModel="initmodle"
                   :title="title"
                   :method="GetmemeberList"
                   :detial_list="detial_list"></account-con>
    </div>
  </div>
</template>

<script>
import accountCon from './account/addaccount.vue'
import formatDate from "@/assets/js/common.js";
import {
  mapActions
} from "vuex";
export default {
  props: {

  },
  data () {
    return {
      viewDetail: false,
      MemberList: [],
      total: 0,
      size: 10,
      page: 1,
      title: '创建账号',
      detial_list: {}
    };
  },
  mounted () {
    this.GetmemeberList()
  },
  methods: {

    initmodle () { this.viewDetail = false },
    ...mapActions({
      memeberList: "pressimApi/memeberList",
      memeberDelete: "pressimApi/memeberDelete",
      memeberStatus: "pressimApi/memeberStatus",

    }),
    // 时间转化
    changeTime (time) {
      return formatDate.getRQ(time);
    },
    sizeChange (val) {
      this.size = val;
      this.GetmemeberList()
    },
    handleSizeChange (val) {
      this.page = val;
      this.GetmemeberList()
    },
    handleClick (key, row) {
      switch (key) {
        case 1:
          this.viewDetail = true
          this.title = '创建账号'

          break;
        case 2:
          this.viewDetail = true
          this.title = '编辑账号'
          this.detial_list = row
          console.log(row, 'row')

          break;
        case 3:
          this.$confirm('此操作将删除该角色, 是否继续?', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',

          }).then(() => {
            /*  this.$message({
               type: 'success',
               message: '删除成功!'
             });memeberDelete */
            this.delehandle(row)
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });

          break;
        case 4:
         row.status==0?this.setmemeberStatus(row,1):this.setmemeberStatus(row,0)
          break;
        default:
          break;
      }

    },
    delehandle (row) {
      let params = {
        token: this.$store.state.token,
        id: row.id,
        platform_id: 2//平台ID
      }
      this.memeberDelete(params).then(res => {
        if (res.data.code == 1) {
          this.$message.success("删除成功")
          this.GetmemeberList()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    setmemeberStatus (row, status) {
      let params = {
        token: this.$store.state.token,
        id: row.id,
        status: status//平台ID
      }
      this.memeberStatus(params).then(res => {
        if (res.data.code == 1) {
          this.GetmemeberList()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    GetmemeberList () {
      let opt = {
        token: this.$store.state.token,
        platform_id: 2, //平台ID（接口获取）
        page: this.page, //页数
        size: this.size //页大小
      }
      this.memeberList(opt).then(res => {
        if (res.code == 1) {
          console.log(res, 'res----')
          this.MemberList = res.data.list
          this.total = res.data.count
        } else {
          this.$message.error(res.msg);
        }
      })
    },
  },
  components: {
    accountCon
  },
};
</script>

<style lang="scss" scoped>
.title {
  box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
  width: 100%;
  background: #fff;
  font-size: 18px;
  color: #333;
  width: 100%;
  padding: 15px 32px;
}

.page {
  margin-top: 20px;
  text-align: center;
}

.role_div {
  .title {
    width: 100%;
    background: #fff;
    font-size: 20px;
    color: #000000;
    width: 100%;
    padding: 15px 32px;
    box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
  }

  .center_box {
    width: 100%;
    box-sizing: border-box;
    min-height: 800px;
    padding: 14px 25px;
    background-color: #e9e9e9;
  }

  .center_title {
    box-sizing: border-box;
    width: 100%;
    background-color: #fff;
    height: 76px;
    line-height: 76px;
    padding-left: 45px;
    font-weight: 600;
    color: #333;
    font-size: 16px;

    .center_left_btn {
      width: 93px;
      height: 32px;
      line-height: 32px;
      display: inline-block;
      text-align: center;
      font-size: 14px;
      color: #fff;
      background: #0084ff;
      border-radius: 2px;
    }
  }

  .center-contain {
    margin-top: 5px;
    min-height: 600px;
    background: #fff;
  }

  .RoleStatus {
    display: flex;
    justify-content: center;
    align-content: center;
    line-height: 100%;

    .name {
      display: inline-block;
    }

    .Yuan {
      width: 12px;
      height: 12px;
      background-color: #23ca18;
      border-radius: 50%;
      margin-right: 9px;
    }

    .RYuan {
      width: 12px;
      height: 12px;
      background-color: #f60a0a;
      border-radius: 50%;
      margin-right: 9px;
    }
  }
}
</style>
